<template>
  <div data-app>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button class="md-primary md-simple md-dense" @click="snackbar.show = false">Dismiss</md-button>
    </md-snackbar>
    <md-dialog-alert
      :md-active.sync="alertNotification.show"
      :md-title="alertNotification.title"
      :md-content="alertNotification.message"/>
    <group-card title="Glass Price" icon="local_offer" padded>
      <template slot="actions">
        <md-switch v-model="pageEditable">Edit Details</md-switch>
        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="showImportGlassPriceDialog"
        >
          <md-icon
            id="new-app-icon"
          >note_add</md-icon>
          Import N12 CSV
          <md-tooltip md-direction="top">Import N12 CSV</md-tooltip>
        </md-button>

        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="showImportU12GlassPriceDialog"
        >
          <md-icon
            id="new-app-icon"
          >note_add</md-icon>
          Import U12 CSV
          <md-tooltip md-direction="top">Import U12 CSV</md-tooltip>
        </md-button>
      </template>
      <!-- Import Glass Editor -->
      <md-dialog :md-active.sync="progress_indicator.import_glass_prices">
        <group-card title="Import N12 CSV" icon="attach_file">
          <ValidationObserver ref="form_upload_template">
            <form enctype="multipart/form-data">
              <md-dialog-alert
                :md-active.sync="alertMessage"
                md-title=" "
                :md-content="message" />
              <div class="md-layout">

                <!-- CSV Upload -->
                <md-field>
                  <label>Import CSV file only</label>
                  <md-file v-model="single" name="file" @change="onFileChange" required />
                </md-field>
              </div>
              <div>
                <md-button class="md-primary md-simple md-danger" @click="onDialogCancel">Cancel</md-button>
                <md-button class="md-primary" @click="importGlassPrice">Import</md-button>
                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate" v-if="loading"></md-progress-spinner>
              </div>
            </form>
          </ValidationObserver>
        </group-card>
      </md-dialog>

      <!-- Import Glass Editor -->
      <md-dialog :md-active.sync="progress_indicator_u12.import_u12_glass_prices">
        <group-card title="Import U12 CSV" icon="attach_file">
          <ValidationObserver ref="form_upload_template">
            <form enctype="multipart/form-data">
              <md-dialog-alert
                :md-active.sync="alertMessage"
                md-title=" "
                :md-content="message" />
              <div class="md-layout">

                <!-- CSV Upload -->
                <md-field>
                  <label>Import CSV file only</label>
                  <md-file v-model="single_u12" name="file_u12" @change="onU12FileChange" required />
                </md-field>
              </div>
              <div>
                <md-button class="md-primary md-simple md-danger" @click="onU12DialogCancel">Cancel</md-button>
                <md-button class="md-primary" @click="importU12GlassPrice">Import</md-button>
                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate" v-if="loading"></md-progress-spinner>
              </div>
            </form>
          </ValidationObserver>
        </group-card>
      </md-dialog>
      <form>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item nvic_search">
              <search-text-input class=""
                                 label="Search NVIC"
                                 icon="search"
                                 v-model="glassPriceData.nvic"
                                 :searcher="performSearch"
                                 @select="selectNVIC"
                                 min-length="3"
                                 required
                                 force
              >
                <template v-slot="{ item }">
                  {{ item.nvic }}
                </template>
              </search-text-input>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="code">Code</label>
                <md-input id="code" :disabled="!pageEditable"
                          v-model="glassPriceData.code" />
              </md-field>
            </div>
            <div class="md-layout-item">
              <validated-autocomplete-input
                id="make"
                label="Make" v-model="glassPriceData.make"
                :options="all_makers"
                :disabled="!pageEditable"
              ></validated-autocomplete-input>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <validated-autocomplete-input
                id="model"
                label="Model" v-model="glassPriceData.model"
                :options="models"
                :disabled="!pageEditable"
              ></validated-autocomplete-input>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="variant">Variant</label>
                <md-input id="variant" :disabled="!pageEditable"
                          v-model="glassPriceData.variant" />
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="series">Series</label>
                <md-input id="series" :disabled="!pageEditable"
                          v-model="glassPriceData.series"/>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="style">Style</label>
                <md-input id="style" :disabled="!pageEditable"
                          v-model="glassPriceData.style"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="injection">Injection</label>
                <md-input id="injection" :disabled="!pageEditable"
                          v-model="glassPriceData.injection" />
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="engine_cc">Engine CC</label>
                <md-input id="engine_cc" :disabled="!pageEditable"
                          v-model="glassPriceData.engine_cc" />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="engine_capacity">Engine Capacity</label>
                <md-input id="engine_capacity" :disabled="!pageEditable"
                          v-model="glassPriceData.engine_capacity"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="transmission">Transmission</label>
                <md-input id="transmission" :disabled="!pageEditable"
                          v-model="glassPriceData.transmission"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="cylinders">Cylinders</label>
                <md-input id="cylinders" :disabled="!pageEditable"
                          v-model="glassPriceData.cylinders"/>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="avg_price">Avg Price</label>
                <md-input id="avg_price" :disabled="!pageEditable"
                          v-model="glassPriceData.avg_price"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="a_avg_price">A Avg Price</label>
                <md-input id="a_avg_price" :disabled="!pageEditable"
                          v-model="glassPriceData.a_avg_price"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="b_avg_price">B Avg Price</label>
                <md-input id="b_avg_price" :disabled="!pageEditable"
                          v-model="glassPriceData.b_avg_price"/>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="width">Width</label>
                <md-input id="width" :disabled="!pageEditable"
                          v-model="glassPriceData.width"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label>Month</label>
                <md-select id="month" :disabled="!pageEditable"
                           v-model="glassPriceData.month">
                  <md-option v-for="item in months" v-bind:key="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label>Year</label>
                <md-select id="year" :disabled="!pageEditable"
                           v-model="glassPriceData.year">
                  <md-option v-for="item in years" v-bind:key="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label for="bt">BT</label>
                <md-input id="bt" :disabled="!pageEditable"
                          v-model="glassPriceData.bt"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="et">ET</label>
                <md-input id="et" :disabled="!pageEditable"
                          v-model="glassPriceData.et"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label for="tt">TT</label>
                <md-input id="tt" :disabled="!pageEditable"
                          v-model="glassPriceData.tt"/>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </form>

      <md-button class="md-button md-raised md-danger md-fab-bottom-left"
                 v-if="isEditForm"
                 @click="removeGlassPrice">
        <md-icon>close</md-icon>
      </md-button>
      <md-button class="md-raised md-primary md-fab-bottom-right float-right"
                 v-if="pageEditable"
                 @click="saveGlassPrice"
                 :disabled="isSaving"
      >
        <md-icon>save</md-icon>
        save
      </md-button>
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import filters from "@/components/utils/filters";
import {newGlassPrice} from "@/schema.js";
import {mapGetters} from "vuex";
import EditApplicantAddress from "@/components/Editors/EditApplicantAddress";
import SearchTextInput from "../components/ValidatedInput/SearchTextInput";
import ValidatedInputs from '@/components/ValidatedInput';
import ValidatedTextInput from "../components/ValidatedInput/ValidatedTextInput";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import LoadingIconButton from '@/components/LoadingIconButton';
import WaitingDialog from "../components/Dialogs/WaitingDialog";
import AlertDialog from "../components/Dialogs/AlertDialog";

export default {
  components: {
    ValidatedSelectInput,
    EditApplicantAddress,
    LoadingIconButton,
    ...ValidatedInputs,
    GroupCard,
    WaitingDialog,
    ConfirmDialog,
    SearchTextInput,
    ValidatedTextInput,
  },
  data() {
    return {
      single: '',
      single_u12: '',
      file: null,
      file_u12: null,
      loading: false,
      alertMessage: false,
      message: '',
      models: [],
      nvic: [],
      glassPriceData: new newGlassPrice(),
      progress_indicator: {
        import_glass_prices: null,
        dialog_title: 'Import Glass Prices',
      },
      progress_indicator_u12: {
        import_u12_glass_prices: null,
        dialog_title: 'Import Glass Prices',
      },
      pageEditable: true,
      glassPriceId: this.$route.params.glass_price_id,
      isSaving: false,
      isEditForm: false,
      snackbar: {
        show: false,
        icon: 'done',
        content: '',
      },
      alertNotification: {
        show: false,
        title: '',
        message: ''
      },
      headers: [
        {text: 'id', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Email', value: 'email'},
      ]
    }
  },
  filters: {
    ...filters,
  },
  computed: {
    ...mapGetters([
      'options',
      'all_makers',
    ]),
    months() {
      return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from({length: year - 1959}, (value, index) => (1960 + index).toString());
    },
  },
  watch: {
  },
  created() {
    this.getGlassPriceDetails();
    this.getAllMakes();
    this.getAllModels();
  },
  methods: {
    onFileChange(event) {
      this.file = event.target.files[0];
      this.single = this.file.name;
    },
    onU12FileChange(event) {
      this.file_u12 = event.target.files[0];
      this.single_u12 = this.file_u12.name;
    },
    showImportGlassPriceDialog() {
      // Reset file when open modal
      this.single = '';
      this.file = false;
      //set the tile
      this.progress_indicator.dialog_title = 'Import Glass Prices';
      //show the dialog
      this.progress_indicator.import_glass_prices = true;
    },
    showImportU12GlassPriceDialog() {
      // Reset file when open modal
      this.single_u12 = '';
      this.file_u12 = false;
      //set the tile
      this.progress_indicator_u12.dialog_title = 'Import Glass Prices';
      //show the dialog
      this.progress_indicator_u12.import_u12_glass_prices = true;
    },
    onDialogCancel() {
      this.progress_indicator.import_glass_prices = false;
    },
    onU12DialogCancel() {
      this.progress_indicator_u12.import_u12_glass_prices = false;
    },
    async importGlassPrice() {
      this.loading = true;

      const payload = {
        'file': this.file,
        'u12': 0
      };

      if (this.file === null || this.file === undefined || this.file === false) {
        this.$modal.show(AlertDialog, {
          title: "Error",
          message: "Please select CSV file!"
        });
      } else {
        try {
          let result = await this.$store.dispatch('store_csv_glass_prices', payload)
          if (result.message != null) {
            this.$modal.show(AlertDialog, {
              title: "Error",
              message: result.message
            });
          } else if (result.status === 200) {
            this.$modal.show(AlertDialog, {
              title: "Success",
              message: result.data
            });
            this.progress_indicator.import_glass_prices = false;
          } else {
            this.$modal.show(AlertDialog, {
              title: "Error",
              message: "Something went wrong!"
            });
          }
        } catch (error) {
          this.$modal.show(AlertDialog, {
            title: "Error",
            message: "Failed to upload CSV!"
          });
        }
      }
      this.loading = false;
      this.file = false;
      this.single = '';
    },
    async importU12GlassPrice() {
      this.loading = true;

      const payload = {
        'file': this.file_u12,
        'u12': 1
      };

      if (this.file_u12 === null || this.file_u12 === undefined || this.file_u12 === false) {
        this.$modal.show(AlertDialog, {
          title: "Error",
          message: "Please select CSV file!"
        });
      } else {
        try {
          let result = await this.$store.dispatch('store_csv_glass_prices', payload)
          if (result.message != null) {
            this.$modal.show(AlertDialog, {
              title: "Error",
              message: result.message
            });
          } else if (result.status === 200) {
            this.$modal.show(AlertDialog, {
              title: "Success",
              message: result.data
            });
            this.progress_indicator.import_glass_prices = false;
          } else {
            this.$modal.show(AlertDialog, {
              title: "Error",
              message: "Something went wrong!"
            });
          }
        } catch (error) {
          this.$modal.show(AlertDialog, {
            title: "Error",
            message: "Failed to upload CSV!"
          });
        }
      }
      this.loading = false;
      this.file = false;
      this.single = '';
    },
    async getGlassPriceDetails() {
      if (this.glassPriceId != undefined) {
        this.pageEditable = false;
        const response = await axios.get(`/api/v1/administration/glass_prices/${this.glassPriceId}`);
        this.glassPriceData = response.data;
      }
    },
    async saveGlassPrice() {
      if (this.validateInputs()) {
        this.isSaving = true
        try {
          const response = await axios.post('/api/v1/administration/glass_prices', this.glassPriceData)
          if (response.data.status) {
            this.snackbar = {
              show: true,
              icon: 'done',
              content: response.data.message
            }
            this.isSaving = false
            Object.assign(this.glassPriceData, new newGlassPrice());
            this.pageEditable = true
            this.isEditForm = false
          } else {
            this.snackbar = {
              show: true,
              icon: 'error',
              content: response.data.message
            }
            this.isSaving = false
            this.isEditForm = false
            this.pageEditable = true
          }
        } catch (e) {
          this.snackbar = {
            show: true,
            icon: 'error',
            content: 'Could not save the details.'
          }
          this.isSaving = false
          this.pageEditable = false
        }
      } else {
        this.showAlert('Missing Fields', 'Please fill all the required fields.');
      }
    },
    async getAllMakes() {
      await this.$store.dispatch("load_all_make")
    },
    async getAllModels() {
      const response = await axios.post('/api/v1/get_models_data')
      this.models = response.data
    },
    async performSearch(query) {
      try {
        let params = {nvic_search: query};
        let response = await this.$store.dispatch("performSearchNvic", params);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async selectNVIC(result) {
      try {
        let response = await this.$store.dispatch("selectNvicMethod", result.id);
        Object.assign(this.glassPriceData, response.data);
        this.isEditForm = true;
      } catch (error) {
        console.error(error);
      }
    },
    async removeGlassPrice() {
      try {
        const res = await this.showNotification(
          "Confirm",
          "This record will be deleted permanently. Continue?",
          "Confirm",
          "Cancel"
        );
        if (!res) {
          return;
        }
        let result = await this.$store.dispatch("remove_glass_price", {
          id: this.glassPriceData.id
        });
        this.snackbar = {
          show: true,
          icon: 'done',
          content: 'Glass Price Deleted successfully!'
        }
        Object.assign(this.glassPriceData, new newGlassPrice());
        this.pageEditable = true
        this.isEditForm = false
      } catch (e) {
        console.log(e, "error obj");
        this.snackbar = {
          show: true,
          icon: 'error',
          content: e.message
        }
      }
    },
    showSuccessDialog(message) {
      this.snackbar.show = true;
      this.snackbar.icon = "done";
      this.snackbar.content = message;
    },
    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
    validateInputs() {
      if (!(this.glassPriceData.nvic)) {
        return false;
      }
      return true;
    },
    showAlert(title, message) {
      this.alertNotification.title = title;
      this.alertNotification.message = message;
      this.alertNotification.show = true;
    },
  }
}
</script>
<style scoped lang="scss">
.float-right {
  float: right;
}

.nvic_search {
  background-color: #2196f340 !important;
}
</style>
